module.exports = __webpack_public_path__ + "img/special_whiteningessence_202402.1bafe30e.jpg";